module.exports = __webpack_public_path__ + "static/media/background-vertical.a7f98978.png";